import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function LoadingVerification() {
  return <WarehouseOpsPage mode="loading" title="Loading & Verification" subtitle="Scan packages loaded into a vehicle" />;
}
